import { memo, useCallback } from 'react';

import {
    StyledClearIcon,
    StyledSearchBar,
    StyledSearchIcon,
    StyledSearchInput,
    StylesClearButton,
} from './CustomSearch.style';

export const CustomSearch = memo(function CustomSearch({
    search,
    setSearch,
}: {
    search: string;
    setSearch: (e: string) => void;
}) {
    const handleInput = useCallback(
        e => {
            setSearch(e.target.value);
        },
        [setSearch],
    );

    const clear = useCallback(() => {
        setSearch('');
    }, [setSearch]);

    return (
        <StyledSearchBar>
            <StyledSearchInput
                inputProps={{
                    sx: {
                        '&::placeholder': {
                            fontFamily: 'Roboto',
                            fontSize: '18px',
                            fontWeight: '300',
                            letterSpacing: '0',
                            lineHeight: '21px',
                            color: '#FFFFFF',
                        },
                    },
                }}
                placeholder="Search"
                value={search}
                onChange={handleInput}
            />
            {!!search.length && (
                <StylesClearButton size="small" onClick={clear}>
                    <StyledClearIcon />
                </StylesClearButton>
            )}
            <StyledSearchIcon />
        </StyledSearchBar>
    );
});
